import localRequest from '../services/LocalServer/localRequest';

async function outOfOrderRequest(outInterval, machineID) {
  if (window.location.pathname.indexOf('/machineUI/out-of-order') !== 0) {
    await localRequest({
      method: 'get',
      url: '/outOfOrderRequest',
    }).then((res) => {
      if (res.data.status) {
        clearInterval(outInterval);
        if (res.data.reason === 'MANUAL') {
          window.location.href = `/machineUI/out-of-order/${machineID}`;
        } else {
          window.location.href = `/machineUI/out-of-order/${machineID}`;
        }
      }
    });
  }
}

async function reinstateRequest(outInterval, machineID) {
  await localRequest({
    method: 'get',
    url: '/outOfOrderRequest',
  }).then((res) => {
    if (!res.data.status) {
      clearInterval(outInterval);
      window.location.href = `/machineSignin`;
    }
  });
}

export { outOfOrderRequest, reinstateRequest };
